import { PopoverProps, Popover as _Popover } from 'antd';

import { getClassName } from '../_utils';

type Props = Pick<
  PopoverProps,
  | 'arrow'
  | 'children'
  | 'className'
  | 'onOpenChange'
  | 'overlayClassName'
  | 'placement'
  | 'styles'
  | 'trigger'
> & {
  content: React.ReactNode;
};

export function Popover({
  children,
  content,
  className,
  overlayClassName = '',
  ...props
}: Props) {
  return (
    <_Popover
      content={content}
      arrow={false}
      placement="rightTop"
      {...props}
      className={getClassName('popover', className)}
      overlayClassName={`suntex-popover-overlay ${overlayClassName}`}
    >
      {children}
    </_Popover>
  );
}
